<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col
            cols="8"
            offset-md="2"
          >
            <h4>Filter</h4>
            <b-form
              class="needs-validation"
              @submit.prevent="submitFilter"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Tahun"
                    label-for="tahunFilter"
                  >
                    <b-form-select
                      id="tahunFilter"
                      v-model="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="KIB"
                    label-for="kibFilter"
                  >
                    <b-form-select
                      id="kibFilter"
                      v-model="kibFilter"
                      :options="dataKib"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayahFilter"
                  >
                    <b-form-select
                      id="wilayahFilter"
                      v-model="wilayahFilter"
                      :options="dataWilayah"
                      :disabled="!$can('Filter', 'dataInformasi')"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpdFilter"
                  >
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      :disabled="
                        !$can('Filter', 'dataInformasi') &&
                          !$can('Filter-PdUpd', 'dataInformasi')
                      "
                      @input="inputPdUpd"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Keberadaan"
                    label-for="keberadaanFilter"
                  >
                    <b-form-select
                      id="keberadaanFilter"
                      v-model="keberadaanFilter"
                      :options="dataKeberadaan"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Status"
                    label-for="statusFilter"
                  >
                    <b-form-select
                      id="statusFilter"
                      v-model="statusFilter"
                      :options="dataStatus"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col
                cols="12"
                align="right"
                class="pr-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  Filter
                </b-button>
              </b-col>
            </b-form>
          </b-col>
          <b-col
            cols="12"
            class="mt-2"
          >
            <!-- search input -->
            <div class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Cari</label>
                  <b-form-input
                    v-model="searchTerm"
                    placeholder="Tekan Enter"
                    type="text"
                    class="d-inline-block"
                    @keyup.enter="handleSearch"
                  />
                </div>
              </b-form-group>
            </div>
            <!-- table -->
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }"
              :pagination-options="{
                enabled: true,
                perPage: row,
                jumpFirstOrLast: true,
              }"
              :total-rows="totalRecords"
              :is-loading.sync="isLoading"
              mode="remote"
              @on-sort-change="onSortChange"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <!-- Column: aksi -->
                <span v-if="props.column.field === 'aksi'">
                  <span v-if="props.row.status == 4 || props.row.status == 5 || props.row.status == 6 || props.row.status == 7 || props.row.status == 8 || props.row.status == 9">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template
                        v-if="
                          (props.row.status == 4 &&
                            $can('Buat', 'dataInformasi')) ||
                            ((props.row.status == 5 ||
                              props.row.status == 6 ||
                              props.row.status == 7 ||
                              props.row.status == 8 ||
                              props.row.status == 9) &&
                              ($can('Validasi', 'dataInformasi') ||
                                $can('Detail', 'dataInformasi')))
                        "
                        v-slot:button-content
                      >
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="text-body align-middle mr-25"
                        />
                      </template>
                      <b-dropdown-item
                        v-if="
                          (props.row.status == 4 || props.row.status == 6) &&
                            $can('Buat', 'dataInformasi')
                        "
                        :to="{
                          name: 'dataInformasiTambah',
                          params: { id: props.row.id.toString() },
                        }"
                      >
                        <feather-icon
                          icon="Edit2Icon"
                          class="mr-50"
                        />
                        <span>Input</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          props.row.status == 5 &&
                            $can('Validasi', 'dataInformasi')
                        "
                        :to="{
                          name: 'dataInformasiValidasi',
                          params: { id: props.row.id.toString() },
                        }"
                      >
                        <feather-icon
                          icon="Edit2Icon"
                          class="mr-50"
                        />
                        <span>Validasi</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          (props.row.status == 5 ||
                            props.row.status == 6 ||
                            props.row.status == 7 ||
                            props.row.status == 8 ||
                            props.row.status == 9) &&
                            $can('Detail', 'dataInformasi')
                        "
                        :to="{
                          name: 'dataInformasiDetail',
                          params: { id: props.row.id.toString() },
                        }"
                      >
                        <feather-icon
                          icon="Edit2Icon"
                          class="mr-50"
                        />
                        <span>Detail</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'kobar_108'">
                  {{ props.row.kobar_108 }}
                  <br>
                  Noreg: {{ props.row.noreg_108 }}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  Status :
                  <b-badge
                    v-if="props.row.status == 1"
                    variant="light-secondary"
                  >
                    Belum Input Keberadaan
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 2"
                    variant="light-info"
                  >
                    Belum Validasi Keberadaan
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 3"
                    variant="light-danger"
                  >
                    Dikembalikan Keberadaan
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 4"
                    variant="light-success"
                  >
                    Melakukan Input Pada Web
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 5"
                    variant="light-info"
                  >
                    Menunggu Validasi Data Informasi
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 6"
                    variant="light-danger"
                  >
                    Dikembalikan Validasi Data Informasi
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 7"
                    variant="light-secondary"
                  >
                    Belum Cetak QR
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 8"
                    variant="light-primary"
                  >
                    Belum Scan QR dan Foto
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 9"
                    variant="light-success"
                  >
                    Selesai Inventarisasi
                  </b-badge>
                  <br>

                  <div v-if="props.row.keberadaan">
                    Keberadaan :
                    <b-badge
                      v-if="props.row.keberadaan == 0"
                      variant="light-secondary"
                    >
                      Tidak Ada
                    </b-badge>
                    <b-badge
                      v-else-if="props.row.keberadaan == 1"
                      variant="light-success"
                    >
                      Ada
                    </b-badge>
                    <br>
                  </div>
                  <div v-if="props.row.wujud_bmd">
                    Biaya/Beban :
                    <b-badge
                      v-if="props.row.wujud_bmd == 0"
                      variant="light-secondary"
                    >
                      Bukan
                    </b-badge>
                    <b-badge
                      v-else-if="props.row.wujud_bmd == 1"
                      variant="light-success"
                    >
                      Iya
                    </b-badge>
                  </div>
                  <div v-if="props.row.kode_barcode">
                    Barcode : {{ props.row.kode_barcode }}
                  </div>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                    <b-form-select
                      v-model="row"
                      :options="['10','25','50']"
                      class="mx-1"
                      @input="handlePageChange"
                    />
                    <span class="text-nowrap">
                      dari {{ totalRecords }} entri
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="totalRecords"
                      :per-page="row"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @change="handleChangePage"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import vSelect from 'vue-select'
import { generateYears, startYear, generateMonths } from '@/libs/helper'
import master from '@/composables/master'
import cetakDaftarBmd from '@/composables/cetakDaftarBmd'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')
    const month = moment().format('M')

    const tahunFilter = ref($route.query.tahun || year)
    const bulanFilter = ref($route.query.bulan || month)
    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const kibFilter = ref($route.query.kib || 'C')
    const wilayahFilter = ref($route.query.wilayah || '')
    const keberadaanFilter = ref($route.query.keberadaan || '')
    const statusFilter = ref($route.query.status || 4)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value

      if (cookiesJenisAkun.value == 'D') statusFilter.value = 5
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') {
      wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10)
    }

    const dataTahun = ref(generateYears(startYear, year))
    const dataBulan = ref(generateMonths())
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const dataKib = ref([{ text: '-- Semua --', value: '' }])
    const dataProvinsi = ref([])
    const dataWilayah = ref([])
    const dataKecamatan = ref([])
    const dataKelurahan = ref([])
    const dataKeberadaan = ref([
      { value: '', text: '-- Semua --' },
      { value: '1', text: 'Ada' },
      { value: '0', text: 'Tidak Ada' },
    ])
    const dataStatus = ref([
      { value: '', text: '-- Semua --' },
      { value: '4', text: 'Melakukan Input Pada Web' },
      { value: '5', text: 'Belum Validasi Data Informasi' },
      { value: '6', text: 'Dikembalikan Data Informasi' },
      { value: '7', text: 'Belum Cetak QR' },
      { value: '8', text: 'Belum Scan QR dan Foto' },
      { value: '9', text: 'Selesai Inventarisasi' },
    ])

    // variable untuk table
    const rows = ref([])
    const searchTerm = ref('')
    const start = ref(1)
    const row = ref(10)
    const totalRecords = ref(0)
    const sortColumn = ref('')
    const order = ref('')
    const isLoading = ref(false)

    // fungsi ambil data untuk table
    const datatable = async () => {
      isLoading.value = true

      const params = {
        filter_kib: kibFilter.value,
        filter_tahun: tahunFilter.value,
        filter_upd: pdUpdFilter.value,
        filter_keberadaan: keberadaanFilter.value,
        kode_wilayah: wilayahFilter.value,
        filter_status: statusFilter.value,
        length: row.value,
        start: start.value - 1,
        cari: searchTerm.value,
        username: g.$cookies.get('username'),
      }
      const resBmd = await cetakDaftarBmd.getBmd(g, params)
      const { code, list, totalList } = resBmd

      if (code == 200) {
        rows.value = list
        totalRecords.value = totalList
      } else {
        rows.value = []
        totalRecords.value = 0
      }

      isLoading.value = false
    }

    datatable()

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&status=${statusFilter.value}&kib=${kibFilter.value}&tahun=${tahunFilter.value}&keberadaan=${keberadaanFilter.value}`
      window.history.pushState('', '', url)
      start.value = 1
      datatable()
    }

    const handleSearch = () => {
      start.value = 1
      datatable()
    }

    const handlePageChange = () => {
      start.value = 1
      datatable()
    }

    const handleChangePage = page => {
      start.value = (page - 1) * row.value + 1
      datatable()
    }

    const onSortChange = params => {
      sortColumn.value = params[0].field
      order.value = params[0].type
      datatable()
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getKib = async () => {
      const resKib = await master.getKib(g)
      resKib.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataKib.value = resKib
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    getPdUpd()

    // const getStatus = async () => {
    //   let resStatus = await master.getStatus(g)
    //   resStatus.data.unshift({ text: "-- Semua --", value: "" })

    //   dataStatus.value = resStatus.data
    // }

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) pdUpdFilter.value = pdUpdFilterValue.value.value
    }

    getKib()
    getWilayah()
    // getStatus();

    return {
      datatable,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      changeWilayah,
      inputPdUpd,
      submitFilter,
      rows,
      searchTerm,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoading,
      tahunFilter,
      pdUpdFilter,
      kibFilter,
      wilayahFilter,
      bulanFilter,
      keberadaanFilter,
      statusFilter,
      pdUpdFilterValue,
      dataTahun,
      dataPdUpd,
      dataKib,
      dataProvinsi,
      dataWilayah,
      dataKecamatan,
      dataKelurahan,
      dataBulan,
      dataKeberadaan,
      dataStatus,
    }
  },
  components: {
    VueGoodTable,
    vSelect,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      columns: [
        {
          label: 'Aksi',
          field: 'aksi',
          width: '1%',
          sortable: false,
        },
        {
          label: 'Guid ID',
          field: 'guid_aset',
          sortable: false,
        },
        {
          label: 'Kolok',
          field: 'kolok',
          sortable: false,
        },
        {
          label: 'Nalok',
          field: 'nalok',
          sortable: false,
        },
        {
          label: 'Kobar',
          field: 'kobar_108',
          sortable: false,
        },
        {
          label: 'Nabar',
          field: 'nabar_108',
          sortable: false,
        },
        // {
        //     label: 'Noreg',
        //     field: 'noreg_108',
        //     sortable: false
        // },
        {
          label: 'Harga',
          field: 'HARGA',
          sortable: false,
        },
        {
          label: 'Alamat',
          field: 'ALAMAT',
          sortable: false,
        },
        {
          label: 'Ukuran',
          field: 'UKU_SAT',
          sortable: false,
        },
        // {
        //     label: 'Keberadaan',
        //     field: 'keberadaan',
        //     sortable: false
        // },
        // {
        //     label: 'Wujud',
        //     field: 'wujud_bmd',
        //     sortable: false
        // },
        {
          label: 'Status',
          field: 'status',
          sortable: false,
        },
        {
          label: 'Tanggal Oleh',
          field: 'TGLOLEH',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
